Object.defineProperty(exports, "__esModule", { value: true });
var Themes;
(function (Themes) {
    Themes["Azure"] = "azure";
    Themes["Crimson"] = "crimson";
    Themes["Emerald"] = "emerald";
})(Themes = exports.Themes || (exports.Themes = {}));
//# sourceMappingURL=themes.js.map